/**
 * Über Dokumenteneditor (z-[280]–z-[300]) und Stundennachweis (z-[230]–z-[270]),
 * damit die Übersicht aus diesen Dialogen erreichbar bleibt.
 *
 * Dokument/Stundennachweis aus der Übersicht nach vorne: siehe
 * `documentEditorLayers.ts` / `timesheetFlowLayers.ts` (Elevated-Stack ab 320).
 */
export const PROJECT_OVERVIEW_Z = "z-[310]";

/** Dialoge innerhalb der Projektübersicht (Bearbeiten, Fotos, …)
 *  sowie Stundennachweis/Fertigstellung, die aus der Übersicht geöffnet werden. */
export const PROJECT_OVERVIEW_OVERLAY_Z = "z-[320]";

/** Verschachtelte Dialoge der Übersicht (z. B. Foto-Detail, Referenzen)
 *  sowie erste Nested-Ebene des Stundennachweis-Flows über der Übersicht. */
export const PROJECT_OVERVIEW_NESTED_OVERLAY_Z = "z-[330]";
